import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CategoriesState } from "./categories.state";
import { getCategories } from "./categories.thunk";
import { CategoriesResponse } from "./categories.types";

const initialState: CategoriesState = {
  data: null,
  error: null,
  status: "idle",
};

const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    resetCategories: (state) => {
      state.data = null;
      state.error = null;
      state.status = "idle";
    },
  },
  extraReducers: (build) => {
    build
      .addCase(getCategories.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        getCategories.fulfilled,
        (state, action: PayloadAction<CategoriesResponse>) => {
          state.status = "success";
          state.data = action.payload.data;
        },
      )
      .addCase(
        getCategories.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Bir hata oluştu.";
        },
      );
  },
});

export const { resetCategories } = categoriesSlice.actions;
export default categoriesSlice.reducer;
